(() => {
 'use strict';
 if (window.yndLookSelectionInitialized) return;
 window.yndLookSelectionInitialized = true;
 const instances = new Map();
 function initialize(root = document) {
  [...instances].forEach(([grid, dispose]) => { if (!grid.isConnected) dispose(); });
  root.querySelectorAll('[data-look-grid]').forEach(grid => {
   if (instances.has(grid)) return;
   let disposed = false;
   let selected = '';
   let suppressFocus = false;
   let frame = 0;
   const cleanup = [];
   const markers = [...grid.querySelectorAll('[data-look-marker]')];
   const controls = [...grid.querySelectorAll('[data-look-select]')];
   const cards = [...grid.querySelectorAll('[data-look-card]')];
   const line = grid.querySelector('[data-look-line]');
   const listen = (target, event, fn, options) => {
    target.addEventListener(event, fn, options);
    cleanup.push(() => target.removeEventListener(event, fn, options));
   };
   function draw() {
    frame = 0;
    if (disposed) return;
    const marker = markers.find(el => el.dataset.lookMarker === selected);
    const control = controls.find(el => el.dataset.lookSelect === selected);
    if (!marker || !control || marker.hidden) { line?.removeAttribute('d'); return; }
    const bounds = grid.getBoundingClientRect();
    const point = marker.getBoundingClientRect();
    const card = control.closest('[data-look-card]').getBoundingClientRect();
    const label = control.getBoundingClientRect();
    const cx = point.left + point.width / 2 - bounds.left;
    const cy = point.top + point.height / 2 - bounds.top;
    const left = card.left + card.width / 2 < point.left + point.width / 2;
    const endX = (left ? card.right : card.left) - bounds.left;
    const endY = label.top + label.height / 2 - bounds.top;
    const photo = grid.querySelector('.ynd-look-portrait').getBoundingClientRect();
    const elbow = ((left ? photo.left : photo.right) - bounds.left + endX) / 2;
    const startX = cx + (left ? -1 : 1) * point.width / 2;
    line?.setAttribute('d', `M ${startX} ${cy} H ${elbow} V ${endY} H ${endX}`);
   }
   function schedule() { if (!disposed && !frame) frame = requestAnimationFrame(draw); }
   function select(key) {
    selected = key;
    markers.forEach(el => { el.hidden = el.dataset.lookMarker !== key; });
    controls.forEach(el => el.setAttribute('aria-expanded', String(el.dataset.lookSelect === key)));
    cards.forEach(el => el.classList.toggle('is-selected', el.dataset.lookCard === key));
    if (!key) line?.removeAttribute('d');
    else schedule();
   }
   listen(grid, 'pointerover', event => {
    if (event.pointerType === 'touch') return;
    const card = event.target.closest('[data-look-card]');
    if (card) select(card.dataset.lookCard);
   });
   listen(grid, 'pointerleave', event => {
    const keyboardFocus = grid.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
    if (event.pointerType !== 'touch' && !keyboardFocus) select('');
   });
   listen(grid, 'focusin', event => {
    if (suppressFocus) return;
    const control = event.target.closest('[data-look-select]');
    const card = event.target.closest('[data-look-card]');
    const marker = event.target.closest('[data-look-marker]');
    if (control && !control.matches(':focus-visible')) return;
    select(control?.dataset.lookSelect || card?.dataset.lookCard || marker?.dataset.lookMarker || '');
   });
   listen(grid, 'focusout', () => {
    queueMicrotask(() => { if (!grid.contains(document.activeElement)) select(''); });
   });
   listen(grid, 'click', event => {
    const control = event.target.closest('[data-look-select]');
    if (control) {
     select(control.dataset.lookSelect);
     // Mobile choices sit directly above the portrait; keep the viewport stable.
    }
   });
   listen(document, 'pointerdown', event => { if (!grid.contains(event.target)) select(''); });
   listen(document, 'keydown', event => {
    if (event.key !== 'Escape' || !selected) return;
    event.preventDefault();
    const control = controls.find(el => el.dataset.lookSelect === selected);
    suppressFocus = true;
    if (grid.contains(document.activeElement)) control?.focus({preventScroll:true});
    suppressFocus = false;
    select('');
   });
   listen(window, 'resize', schedule, {passive:true});
   grid.querySelectorAll('img').forEach(img => listen(img, 'load', schedule));
   if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    observer.observe(grid);
    cleanup.push(() => observer.disconnect());
   }
   const dispose = () => {
    if (disposed) return;
    disposed = true;
    cleanup.forEach(fn => fn());
    if (frame) cancelAnimationFrame(frame);
    select('');
    instances.delete(grid);
   };
   instances.set(grid, dispose);
   select('');
  });
 }
 initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
 document.addEventListener('shopify:section:unload', event => {
  [...instances].forEach(([grid, dispose]) => { if (event.target.contains(grid)) dispose(); });
 });
 window.addEventListener('pageshow', event => {
  if (!event.persisted) return;
  [...instances.values()].forEach(dispose => dispose());
  initialize();
 });
})();
